/**
 * GOREV TIPI -> PARA BIRIMI CIFTI.
 *
 * `taskType` sunucuda tek bir kod ('USD', 'EUR/USD'). Ekranda ise HER ZAMAN iki
 * para birimi var: fiyatlandirilan (base) ve fiyatin yazildigi (quote). Cevirim
 * tek yerde, cunku "toplam hangi para biriminde" sorusunun yanlis cevabi
 * dogrudan yanlis bir tutar gosterir.
 *
 * Kaynak: dovizhub-mobile/src/shared/utils/account.ts (taskTypeToCurrency).
 */

export type CurrencyPair = {
  /** Islem yapilan doviz — `taskAmount` bu birimdedir. */
  currency: string;
  /** Fiyatin (offer_price) yazildigi birim — TOPLAM bu birimdedir. */
  secondCurrency: string;
  /** Gorunur cift etiketi. */
  code: string;
};

const PAIRS: Readonly<Record<string, CurrencyPair>> = Object.freeze({
  USD: { currency: 'USD', secondCurrency: 'TRY', code: 'USD' },
  EUR: { currency: 'EUR', secondCurrency: 'TRY', code: 'EUR' },
  GBP: { currency: 'GBP', secondCurrency: 'TRY', code: 'GBP' },
  CAD: { currency: 'CAD', secondCurrency: 'TRY', code: 'CAD' },
  AUD: { currency: 'AUD', secondCurrency: 'TRY', code: 'AUD' },
  EURUSD: { currency: 'EUR', secondCurrency: 'USD', code: 'EUR/USD' },
});

/** Bilinmeyen kod icin makul geri donus: kodun kendisi / TRY. */
const fallback = (taskTypeCode: string): CurrencyPair => ({
  currency: taskTypeCode,
  secondCurrency: 'TRY',
  code: taskTypeCode,
});

/** 'EUR/USD' -> 'EURUSD' anahtarina normalize eder. */
export const pairOf = (taskTypeCode: string | null | undefined): CurrencyPair => {
  if (!taskTypeCode) return fallback('');
  return PAIRS[taskTypeCode.replace('/', '')] ?? fallback(taskTypeCode);
};

// directedPair KALDIRILDI (2026-09-23). EUR/USD'de ALISTA cifti ters ceviriyordu (tutar USD, kur
// "USD basina EUR"). Oysa veri modeli yonden BAGIMSIZ: talep acilirken tutar her iki yonde de EUR
// girilir (CreateTaskModal `pair.currency`), teklif fiyati 1 EUR'nun USD karsiligidir, toplam
// USD'dir (sunucu raporlari task_type.second_currency, iki bacak kurali task-legs.js). Yon yalniz
// PARANIN AKIS YONUNU belirler: alista musteri EUR alir USD oder, satista tersi. Ters cevirme ayni
// EUR tutarini USD diye gosteriyor ve buroya kuru ters yazdiriyordu. Mobil `determineCurrency`
// ayni sekilde duzeltildi.
